import { DialogDesignTokens } from '@primeuix/themes/types/dialog';

export const Dialog: DialogDesignTokens = {
  root: {
    borderRadius: '{borderRadius}',
    background: '{surface.50}'
  },
  header: {
    padding: '0.4rem 1.2rem'
  },
  colorScheme: {
    dark: {
      root: {

      }
    }
  }
};
